import { useCallback } from 'react';

export const useScrollTo = () => {
  const scrollTo = useCallback((id: string) => {
    const element = document.getElementById(id);

    if (!element) {
      return;
    }

    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }, []);

  return {
    scrollToElement: scrollTo,
  };
};
